var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLanguage = function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 12,
    rx: 11.433,
    ry: 11.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.24c3.049-2.725 4.573-6.472 4.573-11.24S15.05 3.485 12 .76C8.951 3.485 7.427 7.232 7.427 12S8.95 20.515 12 23.24zM1.138 8.628h21.724M1.138 15.372h21.724"
  })));
};
export default SvgLanguage;